module.exports = __webpack_public_path__ + "img/banner.9bf14e4a.jpg";